import { createElement } from 'react';
import { createRoute } from '@tanstack/react-router';
import { IconSettings } from '@tabler/icons-react';
import type { EzyModule } from '../module';
import { useLayout } from '@hana/shell';
import { Settings } from './Settings';
import { SettingsCompact } from './SettingsCompact';
import { SettingsPhone } from './SettingsPhone';

// Quản trị hệ thống (H-10): Cài đặt cá nhân (10a) · Admin + Nhật ký (10b) · Vai trò & quyền (10c).
// iPad (pad) dùng bản 6 mục + chi tiết; điện thoại dùng danh sách nhóm + bảng trượt; máy tính giữ bản 10 mục.
function SettingsRoute() {
  const l = useLayout();
  return createElement(l === 'phone' ? SettingsPhone : l === 'pad' ? SettingsCompact : Settings);
}

const sysadmin: EzyModule = {
  nav: { key: 'settings', label: 'Cài đặt', icon: IconSettings, items: [{ key: 'settings', label: 'Cài đặt', to: '/ezy/settings' }] },
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/settings', component: SettingsRoute }),
  ],
};
export default sysadmin;
